import { useState, useEffect, useRef } from "react";

export function useAutoScan(runScan) {
  const [autoScan,      setAutoScan]      = useState(false);
  const [autoInterval,  setAutoInterval]  = useState(10);
  const [countdown,     setCountdown]     = useState(null);
  const autoRef = useRef(null);
  const cdRef   = useRef(null);

  useEffect(() => {
    if (autoScan) {
      const ms = autoInterval * 60000;
      let rem = ms / 1000;
      cdRef.current  = setInterval(() => { rem -= 1; setCountdown(Math.round(rem)); if (rem <= 0) rem = ms / 1000; }, 1000);
      autoRef.current = setInterval(() => runScan(), ms);
    } else {
      clearInterval(autoRef.current);
      clearInterval(cdRef.current);
      setCountdown(null);
    }
    return () => { clearInterval(autoRef.current); clearInterval(cdRef.current); };
  }, [autoScan, autoInterval, runScan]);

  return { autoScan, setAutoScan, autoInterval, setAutoInterval, countdown };
}
